export const AW_SF_RECOMMENDATION = 'awSfmcRecommendation';

export interface SfmcRecommendation {
  name: string;
  title: string;
  priority: number;
  items: {
    link: string;
    product_code: string;
  }[];
}
